import { render, staticRenderFns } from "./CustomToast.vue?vue&type=template&id=2a13ff05&scoped=true"
import script from "./CustomToast.vue?vue&type=script&lang=js"
export * from "./CustomToast.vue?vue&type=script&lang=js"
import style0 from "./CustomToast.vue?vue&type=style&index=0&id=2a13ff05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_babel-core@6.26.3_cache-loader@4.1.0_webpack@5.10_ei55e3dlglycqw3km3vwexq5ke/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13ff05",
  null
  
)

export default component.exports